<!-- <p class="debugMessage"><small>Profile:</small></p> -->
<div class="content" style="height: fit-content; padding: var(--default-padding);">
	<!-- div-Screen-50 -->
	<div *ngIf="editUser" style=" min-width: 40%; background-color: white;">

		<div *ngIf="auth.user$ | async as user" style="margin-left: auto;padding: 1em; ">
			<div class="flexDiv " style="display: flex; flex-wrap: wrap; text-align: left; margin: auto;">
				<div style="max-width: 100px;min-width: 100px; flex: 100% !important;" class="div-center">
					<img [src]="editUser.Picture" class="rounded-circle img-fluid profile-picture mb-3 mb-md-0" />
				</div>
				<div style=" flex: 100% !important;">
					<h2>{{editUser.Name}}</h2>
					<span class="lead text-muted">{{editUser.Email}}</span>
				</div>
			</div>
			<br>
			<div>
				<form [formGroup]="userForm" ngNativeValidate>
					<div *ngIf="error" class="alert alert-danger">{{error}}</div>
					<div *ngIf="success" class="alert alert-success">{{success}}</div>
					<mat-form-field appearance="fill">
						<mat-label>Name</mat-label>
						<input matInput autocomplete="off" formControlName="userName">
					</mat-form-field>
					<div *ngIf="submitted && userForm.get('userName')?.hasError" class="invalid-feedback">
						<div *ngIf="userForm.get('userName')?.hasError('required')">Your First name is required
						</div>
					</div>
					<ng-container *ngIf="currentUser.AdminSite then AdminBlock"></ng-container>

					<!-- New Dropdown Control -->
					<mat-form-field appearance="fill" *ngIf="myAccounts">
						<mat-label>Default Account</mat-label>
						<mat-select formControlName="userDefaultAccount">
							<mat-option *ngFor="let Account of myAccounts"
								[value]="Account.GUID.toLocaleLowerCase()">{{Account.Name}}</mat-option>
						</mat-select>
					</mat-form-field>

					<div>
						<ejs-accordion style="margin-top: 1em;margin-bottom: 1em; border-radius: var(--default-border-radius);">
							<e-accordionitems>
								<e-accordionitem expanded='False'>
									<ng-template #header>
										<div class="alignRow">
											<mat-icon>account_circle</mat-icon>&nbsp;<span>My Preferences</span>
										</div>
									</ng-template>
									<ng-template #content>
										<div><ng-container *ngTemplateOutlet="UserPreferences"></ng-container></div>
									</ng-template>
								</e-accordionitem>
							</e-accordionitems>
						</ejs-accordion>
					</div>

					<div *ngIf="submitted && userForm.get('userDefaultAccount')?.hasError" class="invalid-feedback">
						<div *ngIf="userForm.get('userDefaultAccount')?.hasError('required')">User Default Account is
							required</div>
					</div>

					<button mat-button type="submit" [disabled]="!this.userForm.dirty" (click)="updateUser()"
						style="border-radius: 1em; border: 2px solid;margin-left: auto;margin-right: 1em;">
						Update Details
					</button>
					<button mat-button type="button" *ngIf="this.userForm.dirty" (click)="resetUser()"
						style="border-radius: 1em; border: 2px solid;margin-left: auto;margin-right: 1em;">
						Cancel
					</button>

					<ng-template #AdminBlock>
						<span class="siteAdmin-only" [matTooltip]="'Admin Only'"></span>
						<div class="md-form mb-1 matFormSlider siteAdmin-only-outline">
							<div>
								<mat-label>User Disabled</mat-label>
								<mat-slide-toggle #switchAdmin formControlName="userDisabled"></mat-slide-toggle>
							</div>
						</div>
						<mat-form-field appearance="fill" class="siteAdmin-only-outline">
							<mat-label>User Role</mat-label>
							<mat-select formControlName="userAccessLevel">
								<mat-option *ngFor="let role of accountRoleOptions"
									[value]="role.value">{{role.label}}</mat-option>
							</mat-select>
						</mat-form-field>

						<div *ngIf="submitted && userForm.get('userAccessLevel')?.hasError" class="invalid-feedback">
							<div *ngIf="userForm.get('userAccessLevel')?.hasError('required')">User Role is required
							</div>
						</div>
					</ng-template>
				</form>
			</div>
		</div>

		<ng-template #UserPreferences>
			<span style="margin: 1em;font-size: 1.2rem;">Layout</span>
			<div style="border: 1px solid lightgrey; border-radius: 8px; padding: 10px;">
				<span>Select predefined times for charts:</span>
				<br />
				<span>Asset Trends:</span>
				<app-duration-selector [(duration)]="strDuration"
					(durationChange)="selectTime($event)"></app-duration-selector>
			</div>
			<div style="padding: 0.5em; display: flex; justify-content: flex-end;">
				<button mat-button type="button" (click)="updatePreferences()" [disabled]="!PreferencesChanged"
					style="border-radius: 1em; border: 2px solid;margin-left: auto;margin-right: 1em;">
					Save
				</button>
			</div>
		</ng-template>
	</div>
</div>